"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
const util_1 = require("@app/util");
const ga4_1 = require("@app/ga4");
const session_1 = require("@app/session");
const offerwall_1 = require("@app/offerwall");
const facebook_1 = require("@app/facebook");
/* predefined in weboack.plugins DefinePlugin */
const VERSION = ENV_VERSION;
const COOKIE_PREFIX = 'bi3tracking';
class Tracking {
    constructor(options) {
        this.offerwallClickRegistered = false;
        console.log(`Tracking init version ${VERSION}`);
        this.initOptions(options);
        this.cookies = new util_1.Cookies(COOKIE_PREFIX);
        this.session = new session_1.Session(this.cookies);
        this.request = new util_1.Request(this.endpoint, this.session);
        this.offerwall = new offerwall_1.Offerwall(this.loc, this.linksSelector, this.session);
        this.cookies.set('version', VERSION);
        window.bicrmTracking = this;
    }
    initOptions(options) {
        const { endpoint, loc, linksSelector = '.trackurl', } = options;
        this.endpoint = endpoint;
        this.loc = loc;
        this.linksSelector = linksSelector;
    }
    initGa4(apiKey, measurementId) {
        this.ga4 = new ga4_1.Ga4(apiKey, measurementId);
    }
    // GETTERS
    getGa4() {
        return this.ga4?.get();
    }
    getUtm() {
        return this.session.getUtm();
    }
    getGCLID() {
        return this.session.getGCLID();
    }
    getGoogleIds() {
        return this.session.getGoogleIds();
    }
    track(event, properties) {
        console.log({ properties });
        properties = {
            ...properties,
            details: properties?.detail || {},
            url: window.location.href,
            clicks: this.session.getTracks(),
            navigator: window.navigator,
            resolution: {
                height: window.screen.availHeight || window.screen.height,
                width: window.screen.availWidth || window.screen.width,
            }
        };
        this.session.incrementTracks();
        this.request.track(event, properties).catch((err) => {
            console.warn('Error tracking event', err);
        });
    }
    //// OFFERWALL 
    trackOfferall() {
        this.offerwall.trackLinks();
        // register default click tracker only once — doit() may run on every onRender batch
        if (!this.offerwallClickRegistered) {
            const self = this;
            this.offerwall.addClickEvent(function (e) {
                const offerId = e?.dataset?.offer;
                const href = e?.href;
                self.track('offerwall-click', { offer: href, offerId });
            });
            this.offerwallClickRegistered = true;
        }
        this.offerwall.trackClicks();
    }
    // replace params in offers links used on offerwall page
    doit() {
        this.trackOfferall();
    }
    offerwallAddClickEvent(callback) {
        this.offerwall.addClickEvent(callback);
    }
    offerwallTrackClick() {
        this.offerwall.trackClicks();
    }
    // get facebook pixel id from request params or cookies
    addFacebookPixel() {
        const fbpx = this.session.getFacebookPixelId();
        if (!fbpx) {
            return;
        }
        const facebookPixel = new facebook_1.FacebookPixel(fbpx);
        facebookPixel.add();
    }
}
exports.Tracking = Tracking;
